const items = [
  "Élagage délicat",
  "Jardinage paysager",
  "Taille de haies",
  "Soins arboricoles",
  "Diagnostic sanitaire",
  "Abattage sécurisé",
  "Aménagement de jardins",
  "Entretien d'espaces verts",
];

export const EditorialMarquee = () => {
  const row = [...items, ...items];
  return (
    <section data-testid="editorial-marquee" className="bg-[#1C2B22] border-y border-[#F5F3EE]/10 py-6 overflow-hidden">
      <div className="rb-marquee-track flex whitespace-nowrap w-max">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif-rb italic text-2xl sm:text-3xl text-[#8CA893]/70 px-6">{item}</span>
            <span className="text-[#D4AF37]/50 text-lg">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
};
